// Curated "new & top rated" ranking. Blends a Bayesian-smoothed rating
// (so a single 5-star vote can't top the board) with a freshness boost
// (so newly posted recipes surface for a while). Pure + deterministic;
// ranks a client-side pool. Lives in its own module (no Firebase imports)
// so it can be unit-tested directly.
export function rankCurated(recipes) {
  const now = Date.now();
  const PRIOR = 4;            // pseudo-votes pulling a recipe toward the mean
  const GLOBAL_MEAN = 3.6;    // assumed average rating across the catalog
  const FRESH_WEIGHT = 1.2;   // max rating-points a brand-new recipe borrows
  const HALF_LIFE_DAYS = 21;  // freshness boost decays over ~3 weeks

  const createdMillis = (r) => {
    const c = r.createdAt;
    if (!c) return now;
    if (typeof c.toMillis === 'function') return c.toMillis();
    if (typeof c.seconds === 'number') return c.seconds * 1000;
    const parsed = new Date(c).getTime();
    return Number.isNaN(parsed) ? now : parsed;
  };

  const score = (r) => {
    const v = r.totalRatings || 0;
    const R = r.averageRating || 0;
    const bayes = (v * R + PRIOR * GLOBAL_MEAN) / (v + PRIOR);
    const ageDays = Math.max(0, (now - createdMillis(r)) / 86400000);
    const freshness = Math.exp(-ageDays / HALF_LIFE_DAYS); // 1 (new) → 0 (old)
    return bayes + FRESH_WEIGHT * freshness;
  };

  return [...recipes]
    .map(r => ({ r, s: score(r) }))
    .sort((a, b) => b.s - a.s)
    .map(({ r }) => r);
}
